import React from 'react';
import { BoxWrapper } from 'components/Base';
import Glossary from './Glossary';

const GlossaryWrapper = () => {
  return (
    <BoxWrapper title="Glossary" style={{ margin: '2rem 0' }}>
      <div style={{ padding: '1rem' }}>
        <Glossary />
      </div>
    </BoxWrapper>
  );
};

export default GlossaryWrapper;
